// import { Component } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';
// import { BaseCtl, EventService, ServiceLocatorService } from '@ncs/ncs-lib';

// @Component({
//   selector: 'app-forgot-password',
//   templateUrl: './forgot-password.component.html',
//   styleUrls: ['./forgot-password.component.css']
// })
// export class ForgotPasswordComponent  extends BaseCtl{


//   constructor(public override locator: ServiceLocatorService,
//     private eService: EventService, public override route: ActivatedRoute) {
//     super(locator.config.get("endpoint.user"), locator, route);


//     }

// override ngOnInit(): void {

// }
//     /**
//    * Forgot password
//    */
//     forgotPassword() {
//       let _self = this;

//       _self.form.message = '';

//       let login = _self.form.data['loginId'];

//       if (login == null || login.length == 0) {
//         _self.form.error = true;
//         _self.form.message = 'Please Enter Login Id';
//         return;
//       } else {
//         _self.form.error = false;
//         _self.form.message = '';
//       }

//       let data = {
//         loginId: _self.form.data['loginId'],
//       };
//       let url = _self.locator.config.get("endpoint.login") + "/fp";
//       this.locator.http.post(url, data, function (res: any, error: any) {
//         if (error) {
//           return;
//         }
//         _self.form.error = !res.success;
//         _self.form.message = res.result.message;
//       });
//     }
// }

import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseCtl } from '@ncs/ncs-lib';
import { ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent extends BaseCtl {
  public appName: any;
  public orgName: any;
  public applicationLogo: any = 0;
  public orgLogo: any = 0;

  public keySuffix: any;
  public enableUserSignup: boolean = false;
  public loginByEmail: boolean = true;
  public loginByMobileNo: boolean = false;
  public loginByLoginCode: boolean = false;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private router: Router
  ) {
    super('', locator, route);

    let _self = this;
    _self.locator.config
      .getProperty('CONTEXT_PATH')
      .then((property: string) => {
        _self.keySuffix = property + '-';

        //  Get auth key to extract org/app id
        locator.getPathVariable(route, function (params: any) {
          let authKey = params['authKey'];
          if (authKey) {
            localStorage.setItem(_self.keySuffix + 'cdAuthkey', authKey);
            let [orgId, appId] = authKey.toString().split('.');
            _self.form.data['orgId'] = orgId;
            _self.form.data['id'] = appId;
          } else {
            let cdAuthkey = localStorage.getItem(_self.keySuffix + 'cdAuthkey');
            if (cdAuthkey !== null && cdAuthkey !== 'null') {
              let [orgId, appId] = cdAuthkey.toString().split('.');
              _self.form.data['orgId'] = orgId;
              _self.form.data['id'] = appId;
            }
          }
        });
      });
  }

  override ngOnInit(): void {
    let _self = this;

    // Redirect if already logged in
    const userContextString = localStorage.getItem('cdUser-userContext');
    if (userContextString != null) {
      this.locator.userContext = JSON.parse(userContextString);
      _self.router.navigate(['/dashboard']);
    }

    //  Get app and org details
    _self.locator.config
      .getProperty('endpoint.login')
      .then((property: string) => {
        _self.GetApplicationDetails(_self.form.data['id']);
        _self.getOrgDetails(_self.form.data['orgId']);
      });
  }

  /**
   *  Get Application Details (Logo, Name, Login Options)
   */
  GetApplicationDetails(id: any) {
    var _self = this;
    if (!id || id == -1) {
      return;
    }
    _self.locator.config
      .getProperty('endpoint.application')
      .then((property: string) => {
        let url = property + '/public/applicationDetails/' + id;
        this.locator.http.get(url, function (res: any, error: any) {
          if (error) {
            console.error('Server Error:' + error);
            return;
          }

          if (res.success) {
            // Assign app logo and name
            _self.applicationLogo = res.result.data['logo'];
            _self.appName = res.result.data['name'];

            _self.enableUserSignup = res.result.data?.enableUserSignup;
            _self.loginByEmail = res.result.data?.loginByEmail;
            _self.loginByMobileNo = res.result.data?.loginByMobileNo;
            _self.loginByLoginCode = res.result.data?.loginByLoginCode;

            // Default fallback
            if (
              !_self.loginByEmail &&
              !_self.loginByMobileNo &&
              !_self.loginByLoginCode
            ) {
              _self.loginByEmail = true;
            }
          }
        });
      });
  }

  /**
   *  Get Organization Details
   */
  getOrgDetails(id: any) {
    var _self = this;
    if (!id || id == -1) {
      return;
    }
    _self.locator.config
      .getProperty('endpoint.orgnization')
      .then((property: string) => {
        let url = property + '/public/orgDetails/' + id;
        this.locator.http.get(url, function (res: any, error: any) {
          if (error) {
            console.error('Server Error:' + error);
            return;
          }
          if (res.success) {
            _self.orgLogo = res.result.data['logoId'];
            _self.orgName = res.result.data['name'];
          }
        });
      });
  }

  /**
//  * Forgot password
//  */
  forgotPassword() {
    let _self = this;

    _self.form.message = '';

    let login = _self.form.data['loginId'];

    if (login == null || login.length == 0) {
      _self.form.error = true;
      _self.form.message = 'Please Enter Login Id';
      return;
    } else {
      _self.form.error = false;
      _self.form.message = '';
    }

    let data = {
      loginId: _self.form.data['loginId'],
    };
    let url = _self.locator.config.get("endpoint.login") + "/fp";
    this.locator.http.post(url, data, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
    });
  }
}
